define('lq/modalblur',[
    'jquery'
], function ($) {

    var setBlurValue = function(value) {
        if (!this.data.renderInScrollContainer)
            return;

        var $rootWrapper = this.piping.$app.children('.licquid-action-wrapper');

        var self = this;
        setTimeout(function () {
            if (navigator.userAgent.search("Firefox") > -1) {
                if (value === 0) {
                    $rootWrapper.css({ animation: 'zoom-out 600ms forwards' });
                } else {
                    $rootWrapper.css({ animation: 'zoom-in 600ms forwards' });
                }
            }

            var cssValue = value > 0
                ? 'blur(' + value + 'px)'
                : 'none';

            $rootWrapper.children().each(function() {
                if (!this.classList.contains('licquid-action-view'))
                    $(this).css('backdrop-filter', cssValue);

                $(this).children().each(function() {
                    if (self.$element[0] !== $(this)[0]) // don't blur the drop itself
                        $(this).css('filter', cssValue);
                });
            });
        });
    };

    var applyBlur = function () {
        if ((this.data.blur !== null && this.data.blur !== undefined) && this.data.hasBlur) {
            setBlurValue.call(this, this.data.blur);
        } else if (this.data.hasBlur) {
            setBlurValue.call(this, 0);
        }
    };

    return {
        applyBlur: applyBlur,
        setBlurValue: setBlurValue
    };
});

